'use strict';

var React = require('react');

var SvgReferralCodeMajor = function SvgReferralCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.25a.75.75 0 0 0 0 1.5h.25v3.25a.75.75 0 0 0 1.5 0v-3.25a1.5 1.5 0 0 0-1.5-1.5h-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.25a.75.75 0 0 0 0 1.5h.818l-.993 2.111a1.5 1.5 0 0 0 1.357 2.139h.818a.75.75 0 0 0 0-1.5h-.818l.993-2.111a1.5 1.5 0 0 0-1.357-2.139h-.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.25a.75.75 0 0 0 0 1.5h.818l-.31.66a1.5 1.5 0 0 0 .131 1.504l.414.586h-1.303a.75.75 0 0 0 0 1.5h1.303c1.216 0 1.926-1.371 1.225-2.365l-.414-.586.311-.66a1.5 1.5 0 0 0-1.357-2.139h-.818Z"
  }));
};
SvgReferralCodeMajor.displayName = "ReferralCodeMajor";

exports.SvgReferralCodeMajor = SvgReferralCodeMajor;
